<template>
    <div class="Ope-Dash-Operacional">
        <PageTitle icon="fa fa-bar-chart" main="Dashboard Operacional"
            sub="Indicadores" />
        <div class="Ope-Dash-Operacional">
Dashboard



        </div>
    </div>

    




</template>

<script>
import PageTitle from '../template/PageTitle'






export default {

    name: 'ManutencaoRfiPrincipal',    
    components: { PageTitle }

    
    
}


</script>

<style>

</style>






